import styled from 'styled-components'

export const InfluentialMap = styled.div`
  width: 100%;
`
